import React from "react";
import {Col, Row} from "antd";
import {ContentWrapper, Root} from "./styled";
import Header from "./components/Header";
import Totals from "./components/Totals";
import RecentSales from "./components/RecentSales";
import Counts from "./components/Counts";
import SalesChart from "./components/SalesChart";
import {DashboardProvider} from "contexts/DashboardProvider";
import ExpensesChart from "./components/ExpensesChart";

const Dashboard = () => {
  return (
    <DashboardProvider>
      <Content />
    </DashboardProvider>
  )
}

export const Content = () => {
  return (
    <Root>
      <Header />
      <ContentWrapper>
        <Totals />
        <Row gutter={[16, 16]}>
          <Col span={15} lg={15} md={24}>
            <RecentSales />
          </Col>
          <Col span={9} lg={9} md={24}>
            <Counts />
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12} md={12} sm={24}>
            <SalesChart />
          </Col>
          <Col span={12} md={12} sm={24}>
            <ExpensesChart />
          </Col>
        </Row>
      </ContentWrapper>
    </Root>
  )
}

export default Dashboard
